import React from "react";

import ChecklistRunner from "../base/ChecklistRunner";

import { resourcesChecklistConfiguration } from "./configuration";

const ResourcesChecklist = () => {
  return <ChecklistRunner descriptor={resourcesChecklistConfiguration} />;
};

export default ResourcesChecklist;
